export default __webpack_public_path__ + "static/media/candidate-findJobs.9a3849b3.png";